import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
// import ReactSelectize, {SimpleSelect, MultiSelect} from 'react-selectize';
// import { Field, reduxForm } from 'redux-form';
import FieldError from './FieldError';
// import MultiSelectTags from '../inputs/MultiSelectTags';
// import ComponentsSelect from '../types/ComponentsSelect';
import '../../styles/ReactSelect.css';

const InputField = ({
  input,
  label,
  type,
  rows,
  placeholder,
  style,
  small,
  className,
  // defaultChecked,
  autoFocus,
  meta,
  options,
  labelClassName,
  wrapperClassName,
  containerClassName,
  containerStyle,
  labelStyle,
  dataTest,
  // currentElementId,
  // fieldIndex,
  ...custom
}) => {
  const renderLabel = label ? (
    <label className={labelClassName} style={labelStyle}>
      {label}
    </label>
  ) : null;
  const renderSmall = small ? (
    <small className="text-muted">{small}</small>
  ) : null;
  // const checked = (defaultChecked) ? true : false;
  const fieldErr = <FieldError meta={meta} />;

  const defaultInput = (
    <div className={wrapperClassName}>
      {renderLabel}
      <div className={containerClassName} style={containerStyle}>
        <input
          {...input}
          placeholder={placeholder}
          type={type}
          style={style}
          className={className}
          autoFocus={autoFocus}
          data-test={dataTest}
        />
        {fieldErr}
        {renderSmall}
      </div>
    </div>
  );
  let output;

  switch (type) {
    case 'textarea':
      // debugger;
      output = (
        <div className={wrapperClassName} style={{ width: '100%' }}>
          {renderLabel}
          <div className={containerClassName} style={containerStyle}>
            <textarea
              {...input}
              onChange={custom.onChange || input.onChange}
              placeholder={placeholder}
              rows={rows}
              style={style}
              className={className}
              autoFocus={autoFocus}
            />
            {fieldErr}
            {renderSmall}
          </div>
        </div>
      );
      break;
    case 'checkbox':
      output = (
        <div className={containerClassName} style={containerStyle}>
          <label className="c-input c-checkbox">
            <input
              {...input}
              onChange={custom.onChange || input.onChange}
              type={type}
              className={className}
            />
            <span className="c-indicator" />
            {label}
          </label>
          {fieldErr}
        </div>
      );
      break;
    case 'select':
      output = (
        <div style={{ width: '100%' }}>
          {renderLabel}
          <select
            style={style}
            className={className}
            {...input}
            onChange={custom.onChange || input.onChange}
          >
            {options.map(o => <option value={o.value}>{o.label}</option>)}
          </select>
          {fieldErr}
          {renderSmall}
        </div>
      );
      break;
    /*
    case 'multi-select2':
      console.log('MULTI_SELECT!!!!!!!');

      output = (
       <div style={{ zIndex: 10, width: '100%' }}>
         {renderLabel}
         <MultiSelect
           values = {value}
           options = {options}
           {...input}
           onChange={custom.onChange || input.onChange}
           //delimiters = {[188]}
           //placeholder = {placeholder}
           //autoFocus={autoFocus ? true : false}

           />;
           {fieldErr}
           {renderSmall}
       </div>
      );

      break;
    */

    case 'multi-select':
      let selectedValues;
      if (input.value) {
        if (typeof input.value === 'string') {
          selectedValues = input.value.split(',');
        } else {
          selectedValues = input.value;
        }
      } else {
        selectedValues = [];
      }

      output = (
        <div style={{ width: '100%' }}>
          {renderLabel}
          <Select
            multi
            simpleValue
            autoBlur
            joinValues
            filterOptions={[]}
            searchable={false}
            clearable={false}
            onBlurResetsInput={false}
            onCloseResetsInput={false}
            style={style}
            valueArray={selectedValues}
            {...input}
            onChange={custom.onChange || input.onChange}
            options={options}
          />
          {fieldErr}
          {renderSmall}
        </div>
      );
      break;

    case 'single-select':
      {
        let selectedValue;
        if (input.value) {
          if (typeof input.value === 'string') {
            selectedValue = input.value.split(',');
          } else {
            selectedValue = input.value;
          }
        } else {
          selectedValue = undefined;
        }

        output = (
          <div style={{ width: '100%' }}>
            {renderLabel}
            <Select
              multi={false}
              simpleValue
              autoBlur
              filterOptions={[]}
              searchable={false}
              joinValues={true}
              clearable={false}
              onBlurResetsInput={false}
              onCloseResetsInput={false}
              style={style}
              value={selectedValue}
              {...input}
              onChange={custom.onChange || input.onChange}
              options={options}
            />
            {fieldErr}
            {renderSmall}
          </div>
        );
      }
      break;

    // case 'multiSelectTags':
    //   output = (
    //
    //   );
    //   break;
    case 'input':
      output = defaultInput;
      break;
    default:
      output = defaultInput;
      break;
  }

  return output;
};

InputField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  containerStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  currentElementId: PropTypes.string,
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/form/InputField.js